var title = 'title_title__nqd5t80';

export { title };
//# sourceMappingURL=title.vanilla.mjs.map
